import { Component, OnInit, OnDestroy, Inject, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { News, Rubric } from 'src/app/classes/news';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { MyFile } from 'src/app/classes/fileInfo';
import { FileService } from 'src/app/services/file.service';
import { NewCountersService } from 'src/app/services/new-counters.service';



@Component({
	selector: 'app-news-display',
	templateUrl: './news-display.component.html',
	styleUrls: [ './news-display.component.css' ]
})
export class NewsDisplayComponent implements OnInit, OnDestroy {


	bInProgress = false;
	subscriptions = new Subscription();

	@Input() news = new News();
	contactPerson = "";

  contactPersonPhone = "";
  contactPersonEmail = "";

	bUnfoldedNews = false;

	bAdmin = this.authenticationService.isAdmin();

	@Input() bShowRelease = true;


	constructor(
		public domSanitizer: DomSanitizer,
		private authenticationService: AuthenticationService,
		private router: Router,
		private fileService: FileService,
		private newCountersService: NewCountersService
	) {}


	ngOnInit() {

		if( this.news.contactFirstName || this.news.contactFamilyName ) {

			const arr: string[] = [];
			if( this.news.contactTitle ) arr.push( this.news.contactTitle );
			if( this.news.contactFirstName ) arr.push( this.news.contactFirstName );
			if( this.news.contactFamilyName ) arr.push( this.news.contactFamilyName );
			this.contactPerson = arr.join( " " );

		}

    if(this.news.contactPhone) {
      this.contactPersonPhone = this.news.contactPhone;
    }

    if(this.news.contactEmail) {
      this.contactPersonEmail = this.news.contactEmail;
    }

	}

	ngOnDestroy() {
	}


	clickEdit( id: string ) {
		this.router.navigate( [ "News/bearbeiten" ], { queryParams: { id: id } } );
	}

	downloadFile( attachedFile: MyFile ) {

		this.fileService.downloadFileById( attachedFile.id, attachedFile.file.name );

	}

	toggleNewsContentDisplay() {

		this.bUnfoldedNews = !this.bUnfoldedNews;

		if( this.bUnfoldedNews ) this.markNewsAsRead();

	}

	markNewsAsRead() {

		if( this.news.bSeen ) return;

		this.news.bSeen = true;
		this.newCountersService.decrementNewNews();

	}

}

